import {Component, ViewChild} from '@angular/core';
import {AgGridAngular} from "ag-grid-angular";
import {ColDef, GridReadyEvent} from "ag-grid-community";
import {Observable} from "rxjs";
import {MatDialog} from "@angular/material/dialog";
import {UserDialogComponent} from "./user-dialog/user-dialog.component";
import {UserService} from "../services/user.service";
import {HubspotService} from "../services/hubspot.service";

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent {

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  public columnDefs: ColDef[] = [
    { field: 'id', width: 50, minWidth: 50, maxWidth: 50 },
    { field: 'username', editable: true },
    { field: 'email', editable: true },
    { field: 'firstName', editable: true },
    { field: 'lastName', editable: true },
    { field: 'active', width: 80, minWidth: 80, maxWidth: 80 },
    { field: 'customerId', editable: true },
    { field: 'createdAt' },
  ];

  // DefaultColDef sets props common to all Columns
  public defaultColDef: ColDef = {
    resizable: true,
    sortable: false,
    filter: false,
  };

  public rowData$!: Observable<any[]>;

  constructor(
    private userService: UserService,
    private hubspotService: HubspotService,
    private matDialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  onGridReady(params: GridReadyEvent) {
    this.userService.getUsers().subscribe((res: any) => {
      console.log(res);
      params.api.setRowData(res);
      this.agGrid.api.sizeColumnsToFit();
      // this.rowData$ = res;
    });
  }

  onCellEditingStopped(event: any) {
    this.userService.updateUser(event.data.id, event.data).subscribe((res: any) => {
      console.log(res);
    });
  }

  openUserDialog() {
    this.matDialog.open(UserDialogComponent, {
      width: '600px',
    });
  }
}
